'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'sliders';
var width = 512;
var height = 512;
var aliases = ["sliders-h"];
var unicode = 'f1de';
var svgPathData = 'M112 24l144 0 0 40 256 0 0 64-256 0 0 40-144 0 0-40-112 0 0-64 112 0 0-40zM32 224l272 0 0-40 144 0 0 40 64 0 0 64-64 0 0 40-144 0 0-40-304 0 0-64 32 0zm0 160l32 0 0-40 144 0 0 40 304 0 0 64-304 0 0 40-144 0 0-40-64 0 0-64 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSliders = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;